/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Action_Change_Seat_TypeInputs */



/**
* | output |
* | --- |
* | "Change seat type" |
*
* @param {Members_Action_Change_Seat_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_action_change_seat_type = /** @type {((inputs?: Members_Action_Change_Seat_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Action_Change_Seat_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Platztyp ändern")
	return /** @type {LocalizedString} */ ("Change seat type")
});